<template>
  <div class="xinXiPingTai">
    <div style="position: relative">
      <img src="../assets/images/solution/wangketong-banner.png" class="xinXiPingTai-top">
      <!--      <div style="position: absolute;width: 100%;height: 100%;top: 0px;display: flex;flex-direction: column;align-items: center;justify-content: center">-->
      <!--        <div style="font-size: 60px;font-weight: 500;color: #FFFFFF;line-height: 105px;letter-spacing: 4px;">智慧园区解决方案</div>-->
      <!--        <div style="font-size: 30px;font-weight: 300;color: #FFFFFF;line-height: 75px;letter-spacing: 4px;">—更智慧，更安全，更高效—</div>-->
      <!--      </div>-->
    </div>
    <div class="xinXiPingTai-1">
      <div style="margin-left:20px;text-align:left;height: 24px;font-size: 16px;font-weight: 400;color: rgba(0,0,0,0.5);line-height: 24px;width: 200px">首页 > 解决方案</div>
      <div style="flex: 1;justify-content: center;display: flex;height: 100%">
        <div class="banner_menu" @click="menuTap('/solution-xinXiPingTai')">智慧校园</div>
        <div class="banner_menu " @click="menuTap('/solution-zhiHuiXiaoQu')">智慧园区</div>
        <div class="banner_menu"  @click="menuTap('/solution-wangKeTong')" >商业客流</div>
        <div class="banner_menu banner_menu_sel"  >地产风控</div>
      </div>
      <div style="width: 200px"></div>
    </div>
    <div style="width: 100%;display: flex;flex-direction: column;align-items: center;margin: 100px 0px;">
      <div class="content-title">地产风控</div>
<!--      <div style="display: flex;">-->
<!--        <div class="content_menu" :class="contentIndex==0?'banner_menu_sel':''" @click="contentMenuTap(0)">客流分析</div>-->
<!--        <div class="content_menu" :class="contentIndex==1?'banner_menu_sel':''" @click="contentMenuTap(1)">智能巡店</div>-->
<!--      </div>-->
      <div v-if="contentIndex == 0" style="width: 100%;display: flex;flex-direction: column;align-items: center;margin-top: 20px">
        <div class="content-text-1">楼盘营销合作渠道可以通过报备系统链接或者二维码对意向客户进行报备，系统自动记录报备客户信息、时间和对<br>应的渠道，臻选出该客户有效的报备渠道，便于客户信息收集和渠道佣金的结算。
        </div>
        <img src="../assets/images/solution/dcfk_content1.png" style="width: 850px;height: auto;margin-top: 90px">
        <div style="width: 100%;position:relative;display: flex;flex-direction: column;align-items: center;margin-top: 60px">
          <img src="../assets/images/solution/bg2.png" style="width: 100%;height: auto;max-height:860px;position: absolute;">
          <div style="margin-top: 40px;z-index: 1000" class="content_menu banner_menu_sel">功能特点</div>
          <div class="content-text-1" style="margin-top: 20px;z-index: 1000">楼盘客户识别、客户到访时间记录、轨迹跟踪、成交跟踪、自动判定飞单客户、自动生产飞单客户报告</div>
          <img src="../assets/images/solution/dcfk_content2.png" style="z-index: 1000;width: 900px;height: auto;margin-top: 60px">
        </div>
        <div style="margin-top: 100px" class="content_menu banner_menu_sel">智能软件</div>
        <div class="content-text-1" style="margin-top: 20px">人脸识别摄像头、边缘算法服务器</div>
        <div style="width: 1330px;display: flex;justify-content: center;margin-top: 30px">
          <div style="width: 424px;margin-right: 50px">
            <img src="../assets/images/solution/xxpt_content18.png" style="width: 424px;height: 324px;">
            <div class="content-text-2">客流摄像头</div>
          </div>
          <div style="width: 424px">
            <img src="../assets/images/solution/wkt_content4.png" style="width: 424px;height: 324px;">
            <div class="content-text-2">边缘算法服务器</div>
          </div>
        </div>
      </div>

    </div>
    <div style="width: 100%;height: 235px;background: #1468FF;display: flex;flex-direction: column;align-items: center;justify-content: center">
      <div style="height: 45px;font-size: 32px;font-weight: 500;color: #FFFFFF;line-height: 45px;margin-bottom: 30px">0元免费使用</div>
      <div style="cursor: pointer;text-align: center;width: 200px;height: 60px;background: #FFFFFF;border-radius: 4px;font-size: 22px;font-weight: 400;color: #1468FF;line-height: 60px;"
          @click="toAboutUs">立即申请</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "solution-xinXiPingTai",
  data() {
    return {
      contentIndex: 0
    }
  },
  methods: {
    contentMenuTap(index){
      this.contentIndex = index
    },
    menuTap(routerUrl){
      this.$router.push(routerUrl);
    },
    toAboutUs(){
      this.$router.push({
        path:'/aboutUs',
        query:{pointId:'#contactUs'}
      });
    }
  }
}
</script>

<style scoped>
.xinXiPingTai{
  text-align: center;
  background-color: #FEFFFF;
}
.xinXiPingTai-top{
  width: 100%;
  height: auto;

}
.xinXiPingTai img{
  text-align: center;
}
/*发展趋势*/
.xinXiPingTai-1{
  width: 1330px;
  height: 80px;
  margin: 0 auto;
  border-bottom: 1px solid #D8D8D8;
  display: flex;
  align-items: center;
}

.banner_menu{
  cursor: pointer;
  width: 100px;
  height: 80px;
  font-size: 18px;
  font-family: SourceHanSansCN, SourceHanSansCN;
  font-weight: 500;
  line-height: 80px;
  text-align: center;
}

.banner_menu_sel{
  color: #1468FF;
  border-bottom: 2px solid #1468FF;
}

.content-title{
  width: 168px;
  height: 60px;
  font-size: 42px;
  font-family: SourceHanSerifSC, SourceHanSerifSC;
  font-weight: 500;
  color: #000000;
  line-height: 60px;
  margin-bottom: 30px;
}
.content_menu{
  cursor: pointer;
  width: 128px;
  height: 50px;
  font-size: 25px;
  font-family: SourceHanSerifSC, SourceHanSerifSC;
  font-weight: 400;
  color: rgba(0,0,0,1);
  line-height: 50px;
  margin: 0 10px;
}
.content-text-1{
  height: 72px;
  font-size: 20px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: rgba(33,33,33,0.7);
  line-height: 36px;
}
.content-text-2{
  width: 424px;
  height: 35px;
  font-size: 24px;
  font-family: SourceHanSerifSC, SourceHanSerifSC;
  font-weight: 400;
  color: #000000;
  line-height: 35px;
  margin-top: 5px;
  text-align: center;
}
</style>
